import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { Gallery } from "@/components/Gallery";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { PrivacyPolicy, CookiePolicy } from "@/pages/LegalPages";
import { ProjectPage } from "@/pages/ProjectPage";
import { LangProvider, useLang } from "@/i18n";
import { AnalyticsPageViews } from "@/AnalyticsPageViews";
import { applyHeadMeta } from "@/headMeta";

// Applica title/description/canonical/hreflang corretti per pagina e lingua;
// il risultato finisce anche negli snapshot pre-renderizzati per i crawler
const RouteMeta = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  useEffect(() => {
    applyHeadMeta(pathname, lang);
  }, [pathname, lang]);
  return null;
};

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Services />
      <Portfolio />
      <Gallery />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <LangProvider>
          <AnalyticsPageViews />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/en" element={<Home />} />
            <Route path="/en/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/en/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/en/cookie-policy" element={<CookiePolicy />} />
            <Route path="/progetti/:slug" element={<ProjectPage />} />
            <Route path="/en/progetti/:slug" element={<ProjectPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <RouteMeta />
        </LangProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#0D1B2A", border: "1px solid #F18A00", color: "#E6EBEA", borderRadius: 0 } }} />
    </div>
  );
}

export default App;
